import React from 'react';
import { motion, Reorder } from 'framer-motion';
import { Promotion, PromotionStatus } from '../types';
import { PromotionCard } from '../PromotionCard';
interface KanbanViewProps {
  promotions: Promotion[];
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
  onStatusChange: (id: string, status: PromotionStatus) => void;
}
const COLUMNS: {
  id: PromotionStatus;
  label: string;
}[] = [{
  id: 'active',
  label: 'Researching'
}, {
  id: 'applied',
  label: 'Applied'
}, {
  id: 'pending',
  label: 'Bonus Pending'
}, {
  id: 'completed',
  label: 'Completed'
}, {
  id: 'expired',
  label: 'Expired'
}];
export function KanbanView({
  promotions,
  onEdit,
  onDelete,
  onStatusChange
}: KanbanViewProps) {
  // Group promotions by status
  const columns = COLUMNS.map(col => ({
    ...col,
    items: promotions.filter(p => p.status === col.id)
  }));
  return <div className="flex overflow-x-auto pb-8 gap-6 min-h-[600px] items-start" data-id="element-176">
      {columns.map(column => <div key={column.id} className="min-w-[300px] w-[300px] flex-shrink-0 flex flex-col" data-id="element-177">
          <div className="flex items-center justify-between mb-4 px-1" data-id="element-178">
            <h3 className="font-semibold text-gray-700 flex items-center gap-2" data-id="element-179">
              {column.label}
              <span className="bg-gray-200 text-gray-600 text-xs px-2 py-0.5 rounded-full" data-id="element-180">
                {column.items.length}
              </span>
            </h3>
          </div>

          <div className="bg-gray-50/50 rounded-xl p-2 min-h-[150px] border border-gray-100/50" data-id="element-181">
            {column.items.length === 0 ? <div className="h-24 border-2 border-dashed border-gray-200 rounded-lg flex items-center justify-center text-gray-400 text-sm" data-id="element-182">
                Empty
              </div> : <div className="space-y-3" data-id="element-183">
                {column.items.map(promotion => <PromotionCard key={promotion.id} promotion={promotion} onEdit={onEdit} onDelete={onDelete} onStatusChange={onStatusChange} compact data-id="element-184" />)}
              </div>}
          </div>
        </div>)}
    </div>;
}